export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
export const KEY = "98357e3f-63f1-4001-8baa-198750553a6e";
export const MODAL_CLOSE_SEC = 2.5;